import React from 'react'

import { Stat } from '@/components/Stat'
import { EyebrowType } from '@/fields/eyebrow'
import { Eyebrow } from '@/components/Eyebrow'
import { cn } from '@/utilities/ui'

export const StatsCard: React.FC<{
  variant?: 'olive' | 'powder'
  eyebrow: EyebrowType
  className?: string
  flexClassName?: string
  size?: 'lg' | 'md'
  stats: {
    label: string
    value: string
  }[]
}> = (props) => {
  const { eyebrow, className, flexClassName, size = 'md', stats, variant = 'powder' } = props

  return (
    <div
      className={cn(
        'flex flex-col px-[30px] py-[50px]',
        variant === 'olive' ? 'bg-olive-2' : 'bg-powder',
        className,
      )}
    >
      {eyebrow && (
        <Eyebrow
          variant={variant === 'olive' ? 'light' : 'dark'}
          label={eyebrow.label}
          color={variant === 'olive' ? 'slime' : 'punch'}
          className="mb-[50px]"
        />
      )}
      <div className={cn('flex flex-col gap-[30px]', flexClassName)}>
        {stats.map((stat) => (
          <Stat
            key={stat.label}
            value={stat.value}
            label={stat.label}
            size={size}
            variant={variant === 'olive' ? 'light' : 'dark'}
          />
        ))}
      </div>
    </div>
  )
}
